import { readJson, writeJson } from '@ms-cloudpack/json-utilities';
import path from 'path';
import type { CloudAppContext } from '../types/CloudAppContext.js';
import type { PartialContext } from '../types/Context.js';

/** Context file created by sync upload and read by link, containing a `CloudAppContext`. */
const cloudpackContextFileName = 'cloudpack-context.json';

/**
 * Serialize the context to `cloudpack-context.json`.
 */
export async function serializeContext(
  destinationFolder: string,
  context: PartialContext<
    'packages' | 'packageHashes',
    'config' | 'packageImportPaths' | 'resolveMap' | 'sessionVersion' | 'targetVersions' | 'urls' | 'importMap'
  >,
): Promise<void> {
  const { packageHashes, session } = context;
  const { importMap, resolveMap, config } = session;

  const serializableContext: CloudAppContext = {
    importMap,
    packageHashes: packageHashes.toSerializable(),
    resolveMap,
    config,
  };

  return writeJson(path.join(destinationFolder, cloudpackContextFileName), serializableContext);
}

/**
 * Read the serialized context from `cloudpack-context.json` under `folder`, but don't
 * do any deserialization of the values.
 */
export async function readSerializedContext(folder: string): Promise<CloudAppContext> {
  const context = await readJson<CloudAppContext>(path.join(folder, cloudpackContextFileName));
  if (!context) {
    throw new Error(
      `Could not find ${cloudpackContextFileName} in ${folder}. This must be a Cloudpack bug, please report it.`,
    );
  }

  return context;
}
